export default {
  gutterBottom: {
    marginBottom: 8
  },
  fontFamily: [
    'Chilanka',
    'cursive',
  ].join(',')
};
